function routerConfig($stateProvider) {
  'ngInject';

  let checkPlanController = function ($state, RegistrationService) {
    'ngInject';

    if (!RegistrationService.formData.plan) {
      const planId = $state.params['planId'];
      const plan = (RegistrationService.ecourse.plans || []).find(({ id }) => String(id) === planId);

      if (!plan) {
        $state.go($state.$current.parent.toString());
      } else {
        RegistrationService.formData.plan = plan;
        $state.go('app.ecourse.registration.purchase.complete');
      }
    }
  };

  $stateProvider
    .state('app.ecourse.registration', {
      abstract: true,
      params: {
        direction: 'forward'
      }
    })
    .state('app.ecourse.registration.purchase', {
      url: '/register/:planId',
      views: {
        'app.layout@app': {
          templateUrl: 'app/ecourse/registration/shared/layout.html',
          controller: 'PurchaseController',
          controllerAs: 'ctrl'
        },
        'step@app.ecourse.registration.purchase': {
          templateUrl: 'app/ecourse/registration/shared/plans.html'
        },
      },
      data: {
        title: 'Join Class',
        back: false
      }
    })
    .state('app.ecourse.registration.purchase.complete', {
      url: '/complete',
      views: {
        'step@app.ecourse.registration.purchase': {
          controller: checkPlanController,
          templateUrl: 'app/ecourse/registration/purchase/complete.html'
        }
      },
      data: {
        back: true
      }
    })
    .state('app.ecourse.registration.gift', {
      url: '/gift',
      views: {
        'app.layout@app': {
          templateUrl: 'app/ecourse/registration/shared/layout.html',
          controller: 'GiftController',
          controllerAs: 'ctrl'
        },
        'step@app.ecourse.registration.gift': {
          templateUrl: 'app/ecourse/registration/shared/plans.html'
        }
      },
      data: {
        title: 'Gift Class',
        back: false
      }
    })
    .state('app.ecourse.registration.gift.completeSignUp', {
      url: '/sign-up',
      views: {
        'step@app.ecourse.registration.gift': {
          controller: checkPlanController,
          templateUrl: 'app/ecourse/registration/gift/completeSignup.html'
        }
      },
      data: {
        back: true
      }
    })
    .state('app.ecourse.registration.gift.complete', {
      url: '/complete',

      views: {
        'step@app.ecourse.registration.gift': {
          controller: checkPlanController,
          templateUrl: 'app/ecourse/registration/gift/complete.html'
        }
      },
      data: {
        back: true
      }
    })
    .state('app.ecourse.registration.redeem', {
      url: '/redeem?redemptionCode',
      views: {
        'app.layout@app': {
          templateUrl: 'app/ecourse/registration/shared/layout.html',
          controller: 'RedeemController',
          controllerAs: 'ctrl'
        },
        'step@app.ecourse.registration.redeem': {
          templateUrl: 'app/ecourse/registration/redeem/complete.html'
        }
      },
      data: {
        title: 'Redeem Class',
        back: false
      }
    });
}

export default routerConfig;



/** WEBPACK FOOTER **
 ** ./src/app/ecourse/registration/registration.route.js
 **/